import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Play } from "lucide-react";
import { Button } from "@akuna/ui";
import { useCanStartAttendance } from "@/hooks/useCanStartAttendance";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";
import type { AppointmentStatus } from "@/hooks/useAppointments";

export function AppointmentStartAttendanceCard({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { t } = useTranslation("calendar");
  const navigate = useNavigate();
  const canStartAttendance = useCanStartAttendance();
  const { appointmentTypeBehavior, appointment, resumePetId, quickStartSource, updateAppointmentStatus, onOpenChange } = ctrl;

  const isStandardOrReturnAppointment =
    appointmentTypeBehavior === "padrao" || appointmentTypeBehavior === "retorno";
  const canOfferStartAttendance =
    isStandardOrReturnAppointment &&
    canStartAttendance &&
    appointment?.status !== "em_atendimento" &&
    appointment?.status !== "cancelado" &&
    appointment?.status !== "finalizado";

  if (!canOfferStartAttendance || !resumePetId || !appointment) return null;

  return (
    <section className="rounded-[18px] border border-border/30 bg-card p-4 shadow-sm">
      <Button
        size="sm"
        className="gap-2 w-full"
        disabled={updateAppointmentStatus.isPending}
        onClick={() => {
          updateAppointmentStatus.mutate(
            { id: appointment.id, status: "em_atendimento" as AppointmentStatus },
            {
              onSuccess: () => {
                onOpenChange(false);
                navigate(`/patients/pets/${resumePetId}/medical-records/new`, {
                  state: { appointmentId: appointment.id, quickStartAttendance: true, quickStartSource },
                });
              },
            },
          );
        }}
      >
        <Play className="h-4 w-4" />
        {t("appointmentDetails.startAttendance")}
      </Button>
    </section>
  );
}
